import {PrimengDropdownOptionInterface} from '@sharedcommon/interfaces/primeng-dropdown-option.interface';
import { ExtendedRowActionModel } from '@sharedcommon/model/primeng-row-action.model';
import {VariableValueImportPreviewDto} from '@sharedrest/data.restservice';

export type PrimengCellClassName = 'red-font' ;

export enum SortOrderTableEnum {
  asc = 1,
  desc = -1
}

/**
 * Primeng table column management interface
 */
export interface PrimengTableCols {
  /**
   * Table header of the column or the tooltip of the icon if it is a icon header
   */
  header: string;
  /**
   * the name of the svg icon
   */
  iconHeaderClassName?: string;
  /** 
   * Identifier of the field value in the row object
   */
  field: string;
  /** 
   * Identifier of the second deep level of the field
   */
  fieldLvl2?: string;
  /**
   * Identifier of the field itself (the name of the column if it is different to the field itself).
   * It will allows us to map the field with the filter attribute and the sort attribute automatically
   */
  forcedFieldIdentifier?: string;
  /**
   * look up table between the data element targeted by field{xxx} attributes and the text to display
   */
  lookupValueTable?: Map<string|boolean|number, string>;
  /**
   * Link to column of condition and formula type define the value of expantion
   */
  fieldExpand?: string;
  /**
   * The key of data which contains a tool tip message
   */
  tooltipMsgKey?: string ;
  /** 
   * At true if you want the cell to take the smallest possible width
   */
  imposeMinWidth?: boolean ;
  /** 
   * Type of the column for the PrimengTableCellTypesComponent component
   */
  type?: 'lock' |
    'date' |
    'booleanDisplay' |
    'calculated' |
    'calculatedCheckbox' |
    'calculatedCheckboxInvert' |
    'calculationIcon' |
    'translationChoose' |
    'formula' |
    'condition' |
    'order' |
    'variableClass' |
    'variableType' |
    'input-text' |
    'input-textarea' |
    'input-dynamicColumn' |
    'input-refCalValue-checkbox' |
    'input-refValue-checkbox' |
    'input-refCalValue' |
    'input-refValue' |
    'input-nutrient' |
    'predictionTooltip' |
    'variableTooltip' |
    'long-text' |
    'innerTranslate' |
    'logo' |
    'formatList' |
    'checkCell' |
    'checkCellMatrixRight' |
    'checkedCell' |
    'importError' |
    'extendedActions' |
    'select';
  /**
   * allows to force the type of filter independently of the type of column.
   */
  filterType?: 'boolean' | 'text';
  /** 
   * action configurations. Taken into account when type is extendedActions
   */
  actions?: ExtendedRowActionModel[];
  /** 
   * Translation field key for update the cell
   */
  translationBaseKey?: string[];
  /**
   * Show or hide the column
   */
  show?: boolean;
  /**
   * Active or not the check all on column
   */
  checkAll?: boolean;
  /**
   * To be use when the ngmodel of the checkbox is not in the table data
   */
  checkOutsideNgModel?: any;
  /**
   * Disable the field if the value is at true
   */
  disable?: boolean;
  /**
   * Placeholder field id for an input-text column
   */
  placeholderFieldId?: string;
  /**
   * Value for the dynamic column
   */
  dynamicValue?: any;
  /**
   * Define if the column is sortable or not
   */
  sortable?: boolean;
  /**
   * Define the default sort order of the column
   */
  defaultSortOrder?: SortOrderTableEnum;
  /**
   * Define the default sort position of the column (for the multi sort)
   */
  defaultSortPosition?: number;
  /**
   * Active or not the filter for the dedicated column
   */
  filterable?: boolean;
  /**
   * pattern of the input text
   */
  pattern?: string;
  /**
   * Column data position
   */
  position?: 'left' | 'right' | 'center';
  /**
   * Return List of cell class to set according row data
   */
  returnCellClasses?: (rowData: any) => PrimengCellClassName[] ;
  /**
   * Options list for the filter of the current col
   */
  filterOptions?: PrimengDropdownOptionInterface[];
  /**
   * Store for the preview object of the import value page
   */
  importPreview?: VariableValueImportPreviewDto;
  // Is a rawMaterial edition column
  isRawMaterialEditColumn?: boolean;
  // Is a deletable column
  isDeletable?: boolean;
  // Can be edit on mass
  canBeMassEdit?: boolean;
  // The option of the select
  options?: any[];
}
